/**
 * Gemeinsame Festlegungen der REST-API (§23).
 *
 * Dieses Modul enthält ausschließlich Pfade, Typen und Fehlercodes. Es darf keine
 * Sicherheitslogik und keine Schlüssel enthalten (§41.2).
 */
/** Basispfad der versionierten API (§23.1). */
export const API_BASE_PATH = '/api/v1';
/** Die vier Bereiche der API (§23.1). */
export const API_AREAS = {
    public: `${API_BASE_PATH}/public`,
    participant: `${API_BASE_PATH}/participant`,
    admin: `${API_BASE_PATH}/admin`,
    system: `${API_BASE_PATH}/system`,
};
/**
 * Bekannte Fehlercodes. Die Liste wächst mit den Entwicklungsstufen.
 *
 * `ANMELDUNG_FEHLGESCHLAGEN` ist absichtlich unspezifisch: nach §9.2 darf nicht erkennbar sein,
 * welcher Teil eines Tokens falsch war oder ob ein Token gesperrt ist.
 */
export const API_ERROR_CODES = {
    UNGUELTIGE_ANFRAGE: 'UNGUELTIGE_ANFRAGE',
    NICHT_ANGEMELDET: 'NICHT_ANGEMELDET',
    KEINE_BERECHTIGUNG: 'KEINE_BERECHTIGUNG',
    ANMELDUNG_FEHLGESCHLAGEN: 'ANMELDUNG_FEHLGESCHLAGEN',
    ZUSTAND_VERALTET: 'ZUSTAND_VERALTET',
    INTERNER_FEHLER: 'INTERNER_FEHLER',
    /** Die Sitzung ist nach 30 Minuten ohne tatsächliche Aktivität abgelaufen (§5.2). */
    SITZUNG_ABGELAUFEN: 'SITZUNG_ABGELAUFEN',
    /**
     * Es besteht bereits eine aktive Sitzung — beim Administrator systemweit (§5.2), beim
     * Teilnehmer für denselben Token auf einem anderen Gerät (§9.6). Die Oberfläche fragt daraufhin
     * nach, ob sie übernommen werden soll.
     */
    SITZUNG_BESTEHT: 'SITZUNG_BESTEHT',
    /** Zu viele fehlgeschlagene Anmeldeversuche, Sperrzeit läuft (§5.3). */
    ZU_VIELE_VERSUCHE: 'ZU_VIELE_VERSUCHE',
    /**
     * Es läuft eine Wartungssperre — derzeit ausschließlich während einer Wiederherstellung
     * (§28.2, §36). Anmeldung und Stimmabgabe sind für die Dauer des Vorgangs ausgesetzt.
     */
    WARTUNG_AKTIV: 'WARTUNG_AKTIV',
    /** Es ist bereits eine Veranstaltung freigegeben oder laufend (§6.3). */
    VERANSTALTUNG_BEREITS_AKTIV: 'VERANSTALTUNG_BEREITS_AKTIV',
    /** Der Statuswechsel ist aus dem aktuellen Status nicht zulässig (§6.2). */
    STATUSWECHSEL_UNZULAESSIG: 'STATUSWECHSEL_UNZULAESSIG',
    /** Die Voraussetzungen für das Löschen sind nicht erfüllt (§6.6). */
    LOESCHEN_NICHT_ZULAESSIG: 'LOESCHEN_NICHT_ZULAESSIG',
    /** Die Obergrenze der Tokens je Veranstaltung ist erreicht (§7.5). */
    TOKEN_OBERGRENZE_ERREICHT: 'TOKEN_OBERGRENZE_ERREICHT',
    /**
     * Der Pool unbenutzter Tokens reicht für den angeforderten E-Mail-Versand nicht aus (ÄA-7).
     * Es wird nichts versendet und kein Token verbraucht — vollständig oder gar nicht (§7.5).
     */
    TOKENS_NICHT_AUSREICHEND: 'TOKENS_NICHT_AUSREICHEND',
    /** Die Abstimmung ist nicht (mehr) geöffnet; eine Stimmabgabe ist ausgeschlossen (§13.5). */
    ABSTIMMUNG_NICHT_GEOEFFNET: 'ABSTIMMUNG_NICHT_GEOEFFNET',
    /** Für diesen Token liegt in dieser Abstimmung bereits eine Stimme vor (§13.1). */
    BEREITS_ABGESTIMMT: 'BEREITS_ABGESTIMMT',
    /** Der Teilnehmer wird in dieser Abstimmung nicht berücksichtigt (§9.9, §7.7). */
    NICHT_STIMMBERECHTIGT: 'NICHT_STIMMBERECHTIGT',
    /** Die übermittelte Auswahl verletzt die Auswahlregeln (§11.5). Es gibt keine Ersatzkategorie. */
    AUSWAHL_UNZULAESSIG: 'AUSWAHL_UNZULAESSIG',
    /**
     * Eine Plausibilitätsprüfung des Schließvorgangs ist fehlgeschlagen (§14.4). Es wurde **nicht**
     * geschlossen, **nichts** gelöscht und **nichts** veröffentlicht.
     */
    PLAUSIBILITAET_FEHLGESCHLAGEN: 'PLAUSIBILITAET_FEHLGESCHLAGEN',
};
//# sourceMappingURL=api.js.map